<!--
    @name: 步骤条组件样式重写
    @description: 默认展示自定义组件，也可以外层传插槽交互
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-12-08 15:48:05
-->
<template>
  <div>
    <div v-if="steparr.length">
      <div class="steps">
        <div v-for="(item,i) in steparr" :key="i" :class="(i+1)==active?'process':(i+1)<active?'success':''">
          <div class="info">{{item}}</div>
        </div>
      </div>
    </div>
    <div v-else>
      <el-steps :active="active" v-bind="$attrs" v-on="$listeners">
        <slot></slot>
      </el-steps>
    </div>
  </div>
</template>

<script>
export default {
  name: "ui-steps",
  inheritAttrs: false,
  props:{
    steparr:{
      type:Array,
      default(){
        return []
      }
    },
    active:{
      type:[String,Number],
      default:1
    }
  }
}
</script>

<style scoped lang="scss">
//自定义风格
.steps{
  display: flex;
  width: 100%;
  counter-reset: section;
  position: relative;
  >div{
    flex:1;
    background: var(--FCeee);
    font-size: var(--FS1);
    .info{
      display: inline-block;
      width: 100%;
      height: 24px;
      line-height: 24px;
      padding: 11px 0;
      text-align: center;
      &:before{
        counter-increment: section;
        content: counter(section);
        display: inline-block;
        box-sizing: border-box;
        width: 24px;
        height: 24px;
        line-height: 24px;
        border-radius: 24px;
        border: 1px solid #B5B5B5;
        margin-right: 10px;
        color: var(--FC6);
      }
    }
    //排除最后一个
    &:not(:last-child){
      &:after{
        content: '';
        position: absolute;
        border-top: 23px transparent dashed;
        border-bottom: 23px transparent dashed;
        border-left: 46px var(--FCeee) solid;
        border-right: 0 transparent dashed;
        z-index: 1;
      }
    }
    //排除第一个
    &:not(:first-child){
      &:before{
        content: '';
        position: absolute;
        margin-top:-5px;
        border-top: 28px transparent dashed;
        border-bottom: 28px transparent dashed;
        border-left: 56px #fff solid;
        border-right: 0 transparent dashed;
      }
    }
  }
  .success{
    .info{
      &:before{
        content:' ';
        border: none;
        background: url("https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639018793790.png") no-repeat left center;
        vertical-align: middle;
        margin-top: -5px;
      }
    }
  }
  .process{
    background: var(--Czsd);
    .info{
      color: var(--FCfff);
      &:before{
        border-color: var(--FCfff);
        color: var(--FCfff);
      }
    }
    &:after{
      //上面的not选择器优先级较高，只能在这用important了
      border-left-color: var(--Czsd) !important;
    }
  }
}
//element默认风格
/deep/ .el-steps{
  .is-finish{
    color: var(--Czsd);
    border-color: var(--Czsd);
  }
  .el-step__main{
    margin-top: 8px;
    .el-step__title,.el-step__description{
      font-size: var(--FS2);
      line-height: var(--FS2);
      margin-top: 0;
    }
    .is-process{
      color: var(--FCc);
    }
  }
  .el-step__head.is-process{
    color: var(--FCc);
    border-color: var(--FCc);
  }
}
//element简洁风格
/deep/ .is-simple{
  .el-step__main{
    margin: 0;
    .is-process{
      color: var(--FC3);
    }
  }
  .el-step__head.is-process{
    color: var(--FC3);
    border-color: var(--FC3);
  }
}
</style>
